import React from 'react';
import NoAccessOverlay from '@/creditflowresearch/ui/common/components/NoAccessOverlay';
import {
  bondScreenerImageCaption,
  bondScreenerNoAccessDescription,
  bondScreenerNoAccessFeatures,
  PAGE_TITLE,
} from '@/creditflowresearch/ui/components/bondscreener/constants';
import image from '@/creditflowresearch/ui/assets/noAccess/bondscreenerNoAccess.webp';

export const BondscreenerNoAccessComponent = (
  <NoAccessOverlay
    title={ PAGE_TITLE }
    features={ bondScreenerNoAccessFeatures }
    description={ bondScreenerNoAccessDescription }
    imageCaption={ bondScreenerImageCaption }
    image={ image.src }
  />
);
